import React, { useState } from 'react';

import classNames from 'classnames';

import * as styles from './pricing.module.css';
import { Toggle } from './toggle';
import SquiggleLineMobile from '../../assets/svg/pricing-squiggle-mobile.inline.svg';
import SquiggleLine from '../../assets/svg/pricing-squiggle.inline.svg';
import WhiteCheck from '../../assets/svg/white-check.inline.svg';
import { AlmaLink } from '../alma-link';
import { PortableText } from '../portableText';

export function Pricing({
  fadeEffects,
  backgroundColor,
  pricing: {
    _rawDescription,
    ctas,
    priceOption1,
    priceOption2,
    disclaimer,
    membershipHeader,
    membershipItems,
  },
  verticalPadding: {
    modulePaddingBottom,
    modulePaddingTop
  }
}) {
  // state
  const [selectedPriceIdx, setSelectedPriceIdx] = useState(0);

  const toggleSwitch = () => {
    const newValue = !selectedPriceIdx ? selectedPriceIdx + 1 : selectedPriceIdx - 1;
    setSelectedPriceIdx(newValue);
  };

  // fade effects
  const enableFadeEffect = fadeEffects?.enableFadeEffect;
  const fadeEffectType = fadeEffects?.fadeEffectType;
  const fadeEffectDirection = fadeEffects?.fadeEffectDirection;

  return (
    <div
      className={
        classNames(
          'responsive-layout',
          modulePaddingTop,
          modulePaddingBottom,
          styles.moduleContainer,
          backgroundColor && `b${backgroundColor}`
        )
      }
    >
      {/* description */}
      <div className={styles.headerContainer}>
        <div className={styles.headerCopyContainer}>
          {_rawDescription && (
            <PortableText blocks={_rawDescription} />
          )}
        </div>
        <Toggle
          onClick={toggleSwitch}
          priceOption1={priceOption1}
          priceOption2={priceOption2}
          selectedPriceIdx={selectedPriceIdx}
        />
      </div>
      {/* pricing */}
      <div className={styles.pricingContainer}>
        <div
          className={
            classNames(
              selectedPriceIdx ? styles.clientGreenBg : styles.darkTealBg,
              styles.pricingCard
            )
          }
        >
          {/* benefits */}
          <div className={styles.benefitsContainer}>
            {membershipHeader && (
              <p
                className={
                  classNames(
                    'heading-xs',
                    styles.benefitsTitle
                  )
                }
              >
                {membershipHeader}
              </p>
            )}
            <ul className={styles.benefits}>
              {membershipItems?.map((membershipItem, idx) => {
                return (
                  <li
                    className={styles.benefit}
                    key={idx}
                  >
                    <WhiteCheck width='24' height='24' />
                    <p
                      className={
                        classNames(
                          'body',
                          styles.benefitCopy
                        )
                      }
                    >
                      {membershipItem}
                    </p>
                  </li>
                );
              })}
            </ul>
          </div>
          {/* pricing */}
          <div className={styles.priceContainer}>
            {!selectedPriceIdx ? (
              <div className={styles.pricing}>
                <p className='body-l'>$</p>
                <h2>{priceOption1?.price}</h2>
                <p>/month</p>
              </div>
            ) : (
              <div className={styles.pricing}>
                <p className='body-l'>$</p>
                <h2>{priceOption2?.price}</h2>
                <p>/year</p>
              </div>
            )}
            <p
              className={
                classNames(
                  'body-s',
                  styles.priceSubheader
                )
              }
            >
              {!selectedPriceIdx ? priceOption1?.priceSubheader : priceOption2?.priceSubheader}
            </p>
          </div>
          <div
            className={
              classNames(
                styles.squiggle,
                styles.desktopSquiggle
              )
            }
          >
            <SquiggleLine />
          </div>
          <div
            className={
              classNames(
                styles.squiggle,
                styles.mobileSquiggle
              )
            }
          >
            <SquiggleLineMobile />
          </div>
        </div>
        {disclaimer && (
          <div className={styles.disclaimerContainer}>
            <p
              className={
                classNames(
                  'body-s',
                  styles.disclaimerCopy
                )
              }
            >
              {disclaimer}
            </p>
          </div>
        )}
      </div>
      {/* call to action */}
      {ctas && ctas.length && (
        <div className={styles.ctaContainer}>
          {ctas?.map((cta, idx) => <AlmaLink cta={cta} key={idx} />)}
        </div>
      )}
    </div>
  );
};
